import {ApiService} from "./api.service";

export class BrandService extends ApiService{
  constructor(organizationId) {
    super();
    // this.endpoint = "/brands";
    this.endpoint = `/organizations/${organizationId}/brands`;
  }

}
